import 'tailwindcss/dist/base.css'

const portal = document.createElement('div')
portal.id = 'portal-root'
document.body.appendChild(portal)

export { wrapRootElement } from './src/apollo/wrap-root-element'
